import { ReactElement } from 'react'
import illustration from '../images/Padasjoki1.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Olen, aloitetaan!',
    gotoStage: 2
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const PadasjokiStage1 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle>Mainiemen sahan elämää</StageTitle>
      <StageText>
        Mainiemen sahan pillin vislaus kaikui kylässä ja vaihtui pian iloiseen puheensorinaan: kello 10 kahvitauko oli alkanut. Sekä sahan, että läheisten maatilojen väki toimivat samassa rytmissä – vielä vuosikymmeniä myöhemminkin. Mainiemi on kuin luotu sahan paikaksi: siellä on pieni luonnon muovaama lampi, joka kanavoitiin Päijänteeseen ja toimi tukkialtaana. Saha loi ympärilleen eläväisen ja omantakeisen kulttuurin ja yhteisön, jota ei muualta löydä
      </StageText>
      <StageText>
        <strong>Oletko valmis ottamaan selvää, millaista hupia säärikilpailu on ollut?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default PadasjokiStage1
